import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'article_type_name',
    field: 'article_type_name',
    type: 'string',
  },
  {
    attribute: 'project_types_name',
    field: 'project_types_name',
    type: 'string',
  },
  {
    attribute: 'project_status_name',
    field: 'project_status_name',
    type: 'string',
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: [
    {
      field: 'publish_date',
      order: 'desc',
    },
    {
      field: 'created',
      order: 'desc',
    },
  ],
};
